<script setup lang="ts">
import { AVPileSummary } from '@assemblyvoting/electa-ui';
import { ContestContent, SelectionPile } from '@aion-dk/js-client/dist/lib/av_client/types';

const props = defineProps<{
  contest: ContestContent,
  selectionPile: SelectionPile,
  editUrl: string,
}>();

function editSelection() {
  window.location.assign(props.editUrl)
}
</script>

<template>
  <AVPileSummary
    :contest="contest"
    :selectionPile="selectionPile"
    @edit-current-selection="editSelection"
    :total-piles="1"
    :active-state="'ballot'"
  />
</template>

<style scoped>

</style>